module.exports = __webpack_public_path__ + "static/media/70-iveco-mercedes.29f515c5.jpg";